<div class="model-security-allocations-chart">
  <div class="block">
    <div class="chart">
      <p-chart type="doughnut" [data]="chartData" [options]="options"
      width="250px" height="250px"></p-chart>
    </div>
  </div>

  @if (categoryTargetPercent && categoryTargetPercent.length !== 0) {
    <div>
      <div class="model-security-allocations-chart-custcat">By {{categoryLabel}}</div>
      <div>
        @for (lst of objectOfCategoryLists.lists; track lst) {
          <div class="model-security-allocations-chart-list">
            @for (item of lst; track item) {
              <div class="model-security-allocations-chart-item">
                <div class="model-security-allocations-chart-custcat-color" [style.backgroundColor]="getColorByCategory(item.category)"></div>
                <div class="model-security-allocations-chart-item-category">{{item.category}}</div>
                <div class="model-security-allocations-chart-item-target">{{item.targetPercent}}
                  %
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
